<template>
  <div class="Tcdt" :class="$route.query.themeStyleVs == 2 ? 'black_theme' : 'white_theme'">
    <div class="title_t">
      <p class="name">热门模拟交易调仓动态</p>
      <p @click="clickMore">更多<van-icon name="arrow" /></p>
    </div>

    <p class="hint" v-if="isLikeToFollow">您关注的热门模拟交易调仓动态将会展示在此模块</p>
    <p class="hint" v-else>
      您关注的热门模拟交易调仓动态将会展示在此模块,因您还没有关注任何热门模拟交易,为您展示最新的模拟交易调仓动态
    </p>
    <ul class="list">
      <li v-for="(item, index) in tcdtList" :key="index" class="list_li" @click="goMnDetail(item)">
        <div class="l_title">
          <p class="decorate"></p>

          <!-- 买卖标志：B－买；S－卖 -->
          <span
            class="state"
            v-if="item.buySell == 'B'"
            :style="$route.query.themeStyleVs == 2 ? 'background: #9A2D31' : 'background: #f58888'"
            >调入</span
          >
          <span
            class="state"
            v-else
            :style="$route.query.themeStyleVs == 2 ? 'background: #1B723D' : 'background:#78cd95'"
            >调出</span
          >
          <span class="time">{{ formatTradeRecordDate(item.dealTime) }}</span>
        </div>

        <div class="l_content">
          <div class="c_top">
            <div class="name">
              <p class="van-ellipsis">{{ item.name }}</p>

              <van-button
                size="mini"
                :color="item.isGz ? '#999' : '#286DF7'"
                plain
                @click.stop="favorFn(item, item.capitalId)"
                >{{ item.isGz ? '已关注' : '关注' }}</van-button
              >
            </div>

            <div class="num">
              <p>
                <span>创建后收益</span>
                <span :class="[judgeColor(item.totalRisk)]">
                  &nbsp;{{ toFixedNum(item.totalRisk * 100, 2, '%') }}
                </span>
              </p>

              <p>
                <span>最大回撤</span>
                <span>&nbsp;{{ toFixedNum(item.maxRetreatRate * 100, 2, '%') }}</span>
              </p>
            </div>
          </div>

          <ul
            class="c_bottom"
            :style="item.stockDeals.length > 3 || item.isCollapse ? 'padding-bottom:0.4rem' : ''"
          >
            <template v-if="!item.isCollapse">
              <li v-for="(item2, index) in item._stockDeals" :key="index">
                ·&nbsp;
                <span class="name van-ellipsis" v-if="!isVip && compareVersions($route.query.version , 9.71)"
                  >****</span
                >
                <span class="name van-ellipsis" v-else>{{ item2.stockName }}</span>
                <span class="num"
                  >价格 <i>{{ toFixedNum(item2.price, 2, '') }}</i></span
                >
                <span class="num"
                  >数量 <i>{{ item2.amount }}</i></span
                >
                <span class="num" style="margin: 0" v-if="item.buySell == 'S'">
                  &nbsp;平仓盈亏
                  <!-- <i :class="[judgeColor(item2.profit)]">{{
                          toFixedNum(item2.profit, 2, '%')
                        }}</i> -->

                  <i :class="[judgeColor(item2.profit)]">
                    &nbsp;{{
                      toFixedNum(
                        (item2.profit / (item2.amount * item2.price - item2.profit)) * 100,
                        2,
                        '%'
                      )
                    }}
                  </i>
                </span>
              </li>
            </template>

            <template v-else>
              <li v-for="(item2, index) in item.stockDeals" :key="index">
                ·&nbsp;
                <span class="name van-ellipsis" v-if="!isVip && compareVersions($route.query.version , 9.71)"
                  >****</span
                >
                <span class="name van-ellipsis" v-else>{{ item2.stockName }}</span>
                <span class="num"
                  >价格 <i>{{ toFixedNum(item2.price, 2, '') }}</i></span
                >
                <span class="num"
                  >数量 <i>{{ item2.amount }}</i></span
                >
                <span class="num" style="margin: 0" v-if="item.buySell == 'S'">
                  &nbsp;平仓盈亏
                  <!-- <i :class="[judgeColor(item2.profit)]">{{
                          toFixedNum(item2.profit, 2, '%')
                        }}</i> -->

                  <i :class="[judgeColor(item2.profit)]">
                    &nbsp;{{
                      toFixedNum(
                        (item2.profit / (item2.amount * item2.price - item2.profit)) * 100,
                        2,
                        '%'
                      )
                    }}
                  </i>
                </span>
              </li>
            </template>

            <!-- 检查是否少于 9 条数据且满足特定条件 @click="showVIP" -->
            <div class="groundGlass" v-if="!isVip && compareVersions($route.query.version , 9.71)">
              <img src="@/assets/image/homeVIP.png" alt="" />
            </div>
          </ul>

          <p
            class="all"
            v-if="item.stockDeals.length > 3 && !item.isCollapse"
            @click.stop="expandContent(index)"
          >
            展开全部
          </p>

          <p class="all" v-if="item.isCollapse" @click.stop="collapseContent(index)">收起</p>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { getHotDynamicsHome, addMyFavor, delMyFavor } from '@/api/index.js';
import { judgeColor, toFixedNum, formatTradeRecordDate,compareVersions } from '@/utils/format';
import mixin from '@/mixins/index.js';

export default {
  name: 'Tcdt',
  mixins: [mixin],
  props: [],

  data() {
    return {
      isVip: false,
      tcdtList: [],
      stockNum: 3,
      isLikeToFollow: true
    };
  },
  filters: {},
  created() {},
  watch: {
    '$store.state.isVip': {
      handler(newValue) {
        this.isVip = newValue;
      },
      immediate: true // 立即执行一次
    }
  },
  async mounted() {
    this.getHotDynamicsHomeFun();
  },
  beforeDestroy() {},
  methods: {
    judgeColor,
    toFixedNum,
    formatTradeRecordDate,
    compareVersions,

    // 获取热门模拟交易调仓动态
    getHotDynamicsHomeFun: function () {
      let _this = this;

      let obj = {};
      getHotDynamicsHome(obj)
        .then((res) => {
          if (res.err === 200) {
            _this.tcdtList = res.data;

            _this.tcdtList.forEach((item) => {
              item.isCollapse = false;

              if (item.stockDeals.length > 3) {
                item._stockDeals = item.stockDeals.slice(0, 3);
              } else {
                item._stockDeals = item.stockDeals;
              }
            });

            _this.isLikeToFollow = _this.checkIsGz(res.data);
          }
        })
        .catch(() => {});
    },

    //循环列表里面是否全部为关注状态
    checkIsGz: function (data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].isGz) {
          return true;
        }
      }
      return false;
    },

    // 更多
    clickMore: function () {
      // 判断是否是 vip
      if(this.isVip == false && compareVersions(this.$route.query.version , 9.92)) {
        let appJson = {
          DialogType: "basic",
        };
        DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
          'factorTYPerDialog',
          JSON.stringify(appJson),
          ''
        );
      } else if (this.isVip == false && compareVersions(this.$route.query.version , 9.71)) {
        // 如果不是VIP用户,弹出VIP提示
        let appJson = {
          channel: 'yinzi',
          dzhadid: '0705'
        };
        DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
          'factorNoVipPerDialog',
          JSON.stringify(appJson),
          ''
        );
      } else {
        this.$router.push({
          path: '/tcdtMore',
          query: this.$route.query
        });
      }
    },

    //点击vip遮罩
    showVIP: function () {
      let appJson = {
        channel: 'yinzi',
        dzhadid: '0705'
      };
      DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
        'factorNoVipPerDialog',
        JSON.stringify(appJson),
        ''
      );
    },

    // 点击关注、已关注按钮
    favorFn: function (item, capitalId) {
      if (item.isGz) {
        this.delFavorFn(item, capitalId);
      } else {
        this.addFavorFn(item, capitalId);
      }
    },
    // 加入关注
    // 1 策略 2 因子 3 模拟盘
    // "2", //类型2-策略  "1",  // 类型1-因子 3 模拟盘
    addFavorFn: function (item, capitalId) {
      let _this = this;

      _this.$toast.loading({
        message: '加载中...',
        duration: 0,
        forbidClick: true
      });

      let obj = {
        type: 3,
        id: item.capitalId,
        s_name: item.name,
        f_id_arr: item.capitalId,
        creator: '',
        counter_num: item.counterCode
      };
      addMyFavor(obj).then((res) => {
        if (res.err === 200) {
          _this.tcdtList.forEach((item) => {
            if (item.capitalId === capitalId) {
              item.isGz = true;
            }
          });
          _this.$toast('关注成功');

          _this.isLikeToFollow = true;
        } else {
          _this.$toast(res.msg);
        }
      });
    },
    // 取消关注
    delFavorFn: function (item, capitalId) {
      let _this = this;

      _this.$toast.loading({
        message: '加载中...',
        duration: 0,
        forbidClick: true
      });

      let obj = {
        type: 3,
        id: item.capitalId
      };
      delMyFavor(obj).then((res) => {
        if (res.err === 200) {
          _this.tcdtList.forEach((item) => {
            if (item.capitalId === capitalId) {
              item.isGz = false;
            }
          });
          _this.$toast('取消关注成功');

          _this.isLikeToFollow = _this.checkIsGz(_this.tcdtList);
        } else {
          _this.$toast(res.msg);
        }
      });
    },

    expandContent: function (index) {
      this.$set(this.tcdtList[index], 'isCollapse', true);
      this.$forceUpdate();
    },

    collapseContent: function (index) {
      this.$set(this.tcdtList[index], 'isCollapse', false);
      this.$forceUpdate();
    },

    // 跳转模拟详情
    goMnDetail: function (item) {
      // 判断是否是 vip
      if(this.isVip == false && compareVersions(this.$route.query.version , 9.92)) {
        let appJson = {
          DialogType: "basic",
        };
        DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
          'factorTYPerDialog',
          JSON.stringify(appJson),
          ''
        );
      } else if (this.isVip == false && compareVersions(this.$route.query.version , 9.71)) {
        // 如果不是VIP用户,弹出VIP提示
        let appJson = {
          channel: 'yinzi',
          dzhadid: '0705'
        };
        DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
          'factorNoVipPerDialog',
          JSON.stringify(appJson),
          ''
        );
      } else {
        location.href = '/mnDetail?DZHSPECIAL=4325641&type=hot&zj_id=' + item.capitalId;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.Tcdt {
  padding: 0 0 0 16px;
  margin-top: 30px;
  .title_t {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 9px;
    padding-right: 16px;
    .name {
      display: flex;
      align-items: center;
      ::v-deep {
        .van-icon-question-o {
          margin-left: 5px;
          margin-top: 2px;
        }
      }
    }
    p {
      color: #222;
      &:first-child {
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
      }
      &:last-child {
        border-radius: 10px;
        background: #f7f8fa;
        padding: 3px 6px 3px 10px;
        font-size: 10px;
        font-weight: 500;
      }
    }
  }

  .hint {
    color: #999;
    font-size: 12px;
  }

  .list {
    border-left: 1px dashed #e5e5e5;
    .list_li {
      padding: 0 15px;
      .l_title {
        display: flex;
        align-items: center;
        margin-top: 18px;
        position: relative;
        .decorate {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          border: 2px solid #999;
          background: #fff;
          position: absolute;
          top: 5px;
          left: -19px;
        }

        .state {
          padding: 0 4px;
          color: #fff;
          font-size: 11px;
          border-radius: 4px;
        }
        .time {
          margin-left: 8px;
          color: #555;
          font-size: 14px;
          font-weight: 600;
        }
      }
      .l_content {
        border: 1px solid #e5e5e5;
        margin-top: 6px;
        border-radius: 8px;
        position: relative;
        .c_top {
          padding: 8px 12px;
          border-bottom: 1px solid #e5e5e5;
          .name {
            display: flex;
            align-items: center;
            justify-content: space-between;
            p {
              color: #555;
              font-size: 16px;
              font-weight: 500;
              width: 250px;
            }
            ::v-deep {
              .van-button {
                border: none !important;
                height: auto !important;
                background: none !important;
                border: none !important;
                // color: #286df7 !important;
              }

              .van-button--default {
              }

              .van-button__text {
                font-size: 12px;
              }
            }
          }

          .num {
            display: flex;
            align-items: center;
            p {
              width: 50%;
              margin-top: 5px;
              span {
                &:first-child {
                  color: #999;
                  font-size: 12px;
                  font-weight: 400;
                }

                &:last-child {
                  color: #555;
                  font-size: 14px;
                  font-weight: 600;
                }
              }
            }
          }
        }

        .c_bottom {
          background: #f7f8fa;
          padding: 6px 12px;
          line-height: 20px;
          position: relative;
          border-radius: 0 0 8px 8px;
          li {
            display: flex;
            align-items: center;
            flex-wrap: wrap;

            .name {
              color: #555;
              font-size: 12px;
              font-weight: 500;
              flex-shrink: 0;
              width: 65px;
            }
            .num {
              color: #999;
              font-size: 11px;
              font-weight: 400;
              margin-right: 12px;
              // width: 100%;
              i {
                color: #555;
                font-size: 11px;
                font-weight: 400;
                font-style: normal;
              }
              &:last-child {
                // width: 110px;
                flex-shrink: 0;
                margin-right: 0;
              }
            }
          }

          .groundGlass {
            backdrop-filter: blur(5px); /* 标准写法 */
            position: absolute;
            z-index: 9;
            top: 0px;
            left: 10px;
            width: 40px;
            height: 100%;
            text-align: center;
            display: flex;
            align-items: center;
            justify-content: center;
            img {
              width: 40px;
              height: 26px;
              margin-left: 4px;
            }
          }
        }
        .all {
          color: #286df7;
          font-size: 11px;
          font-weight: 400;
          position: absolute;
          right: 12px;
          bottom: 2px;
        }
      }
    }
  }
}
</style>

<!-- 黑色主题 -->
<style lang="less" scoped>
.black_theme {
  .title_t {
    p {
      &:first-child {
        color: #e4e9fe;
      }
      &:last-child {
        background: #1d202d;
        color: #e4e9fe;
      }
    }
  }
  .list {
    border-left: 1px dashed #424956;
    .list_li {
      .l_title {
        .time {
          color: #e4e9fe;
        }
      }
      .decorate {
        border: 2px solid #6b7687;
      }
      .l_content {
        background: #272935;
        border: 1px solid #2f3448;
        ::v-deep {
          .van-button {
            background: none;
          }
        }
        .c_top {
          border-bottom: 1px solid #2f3448;
          .name {
            p {
              color: #e4e9fe;
            }
          }
          .num {
            p {
              span {
                &:first-child {
                  color: #6b7687;
                }
                &:last-child {
                  color: #aab9d1;
                }
              }
            }
          }
        }
        .c_bottom {
          background: #2d2f3b;
          li {
            color: #aab9d1;
            .name {
              color: #aab9d1;
            }
            .num {
              color: #6b7687;
              i {
                color: #aab9d1;
              }
            }
          }
        }
        .all {
          background: #2d2f3b;
        }
      }
    }
  }
}
</style>
